import { Button } from '@/components/button'
import { T } from '@/components/t'
import { useRestaurantDetailContext } from '@/features/restaurants/restaurant-detail/restaurant-detail-context'
import { SvgOutlinedPhone } from '@/icons/svg-outlined-phone'
import { COLORS } from '@/utils/styles/colors'

export const RestaurantDetailContact = () => {
    const { restaurant } = useRestaurantDetailContext()

    if (!restaurant) return null

    return (
        <div className="flex flex-col items-start gap-y-4">
            {/* The number is plain text, calling belongs to the button alone */}
            <p className="hidden md:block text-p-sm md:text-p-md">{restaurant.phone}</p>

            <Button
                href={{ externalUrl: `tel:${restaurant.phone}` }}
                styleType="secondary"
                className="gap-x-2"
            >
                <SvgOutlinedPhone size={20} color={COLORS.fg.primary} />

                <T className="text-label-md" t="restaurants.detail.contact.call" />
            </Button>
        </div>
    )
}
